
export default class Content {
    constructor(name, author, content_text, content_type){
        this.name = name
        this.author = author
        this.content_text = content_text
        this.content_type = content_type
    }

}